import { BinderAmendment } from "@dune/types";
import { DataTable } from "@dune/ui";
import { binderWarrantiesColumns } from "./columns/warrantiesColumns";
const BinderWarranties = ({
	binderAmendment,
}: {
	binderAmendment: BinderAmendment;
}) => {
	return (
		<div className="flex flex-col gap-4">
			{binderAmendment.binderWarranties
				.filter(
					(binderWarranty) =>
						binderWarranty?.warrantyType &&
						binderWarranty.warranties.length > 0,
				)
				.map((warranty) => {
					return (
						<div key={warranty.id} className="flex flex-col gap-4">
							<h1 className="text-[#144C65] text-2xl font-medium">
								Garanties de {warranty.name} ({warranty.warrantyType})
							</h1>
							<div className="flex flex-col gap-4">
								<DataTable
									columns={binderWarrantiesColumns}
									data={warranty.warranties}
									noResultsText="Aucune garantie trouvée"
								/>
							</div>
						</div>
					);
				})}
		</div>
	);
};

export default BinderWarranties;
